export enum ColorMode {
  BLACK_BG = 'black_bg',
  GRAY_BG = 'gray_bg',
  WHITE_BG = 'white_bg',
}
